module.exports = __webpack_public_path__ + "static/media/18_profile_picture.b18bd1d4.png";